import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as _ from 'lodash';

import { environment } from 'environments/environment';

import { Issue } from './issue.class';

import { Observable } from 'rxjs/Observable';

const BASE_PATH = '/ws/app/issue';
const BASE_URL = `${environment.API_URL}${BASE_PATH}`;

@Injectable()
export class IssueService {

  constructor(
    public http: HttpClient
  ) {}

  public get(id): Observable<Issue> {
    return this.http.get(`${BASE_URL}/${id}`)
      .map((issueData) => new Issue(issueData));
  }

  public all(): Observable<Issue[]> {
    return this.http.get(BASE_URL)
      .map((listIssueData) =>
        (listIssueData as any[]).map((issueData) => new Issue(issueData))
      );
  }

  public create(issue: Issue): Observable<Issue> {
    return this.http.post(BASE_URL, issue)
      .map((issueData) => new Issue(issueData));
  }

  public update(issue: Issue): Observable<Issue> {
    return this.http.put(`${BASE_URL}/${issue.id}`, issue)
      .map((issueData) => new Issue(issueData));
  }

  public remove(id: string): Observable<any> {
    return this.http.delete(`${BASE_URL}/${id}`);
  }

  public getImageUri(issueId: string, imageId: string): string {
    return `${environment.API_URL}/ws/app/issue/${issueId}/picture/${imageId}`;
  }

  public getPdfUri(id: string): string {
    return `${BASE_URL}/${id}/pdf`;
  }
}



// WEBPACK FOOTER //
// ./src/app/models/issue.service.ts